(function() {
	PM.Plan.ProjectStatus = {};

	PM.Plan.ProjectStatus.STATUS_COLORS = { green: '#28a745', yellow: '#ffc107', red: '#dc3545' };

	// helper functions
	PM.Plan.ProjectStatus.showModal = function(projectId) {
		$.when(
			$.get('/api/projects/' + projectId),
			$.get('/api/projects/' + projectId + '/status'),
			ejs.preloadTemplate('/app/plan/project-status/templates/project-status-modal.ejs')
		).done(function(projectResult, statusResult) {
			var project = projectResult[0];
			var statusData = statusResult[0];

			var html = ejs.rr('/app/plan/project-status/templates/project-status-modal.ejs', {
				project: project,
				rows: statusData.rows,
				latestStatus: statusData.latestStatus
			});

			var $existing = $('.js-project-status-modal');
			if ($existing.length) $existing.remove();

			$('body').append(html);
			var $modal = $('.js-project-status-modal');
			$modal.data('project-id', projectId);
			var bsModal = new bootstrap.Modal($modal[0]);
			bsModal.show();

			$modal.on('hidden.bs.modal', function() {
				$modal.remove();
				PM.Plan.ProjectStatus.refreshDot(projectId);
			});
		});
	};

	PM.Plan.ProjectStatus.refreshDot = function(projectId) {
		$.get('/api/projects/' + projectId + '/status').then(function(statusData) {
			var latestStatus = statusData.latestStatus;

			if (latestStatus) {
				var $dot = $('<span class="js-project-status-dot"></span>')
					.attr('data-project-id', projectId)
					.css({ background: PM.Plan.ProjectStatus.STATUS_COLORS[latestStatus] })
					.attr('title', i18next.t('Status') + ': ' + i18next.t(latestStatus));

				// People view: dot goes in its own .js-project-status-cell
				$('.js-project-status-cell').each(function() {
					var $row = $(this).closest('.js-project-row');
					if ($row.data('project-id') == projectId) {
						$(this).html($dot.clone());
					}
				});

				// Project view: dot goes in .js-project-name header cell
				$('.js-project-name').each(function() {
					var $header = $(this).closest('.js-project-header');
					if ($header.data('project-id') == projectId) {
						var $existingDot = $(this).find('.js-project-status-dot');
						if ($existingDot.length) {
							$existingDot.replaceWith($dot.clone());
						}
					}
				});
			} else {
				var $emptyDot = $('<span class="js-project-status-dot js-project-status-empty"></span>')
					.attr('data-project-id', projectId)
					.attr('title', i18next.t('Status'));

				$('.js-project-status-cell').each(function() {
					var $row = $(this).closest('.js-project-row');
					if ($row.data('project-id') == projectId) {
						$(this).html($emptyDot.clone());
					}
				});

				$('.js-project-name').each(function() {
					var $header = $(this).closest('.js-project-header');
					if ($header.data('project-id') == projectId) {
						var $existingDot = $(this).find('.js-project-status-dot');
						if ($existingDot.length) {
							$existingDot.replaceWith($emptyDot.clone());
						}
					}
				});
			}
		});
	};

	//events
	$(document).on('click', '.js-project-status-dot', function() {
		var projectId = $(this).data('project-id');
		if (!projectId) { return; };
		PM.Plan.ProjectStatus.showModal(projectId);
	});

	$(document).on('submit', '.js-status-form', function(e) {
		e.preventDefault();
		var $form = $(this);
		var $modal = $form.closest('.js-project-status-modal');
		var projectId = $modal.data('project-id');
		var editId = $form.find('.js-status-edit-id').val();
		var data = {
			time_note: $form.find('.js-status-time-note').val() || null,
			budget_note: $form.find('.js-status-budget-note').val() || null,
			quality_note: $form.find('.js-status-quality-note').val() || null,
			status: $form.find('.js-status-value').val()
		};

		var request;
		if (editId) {
			request = $.ajax({
				url: '/api/project-status/' + editId,
				method: 'PUT',
				contentType: 'application/json',
				data: JSON.stringify(data)
			});
		} else {
			request = $.ajax({
				url: '/api/projects/' + projectId + '/status',
				method: 'POST',
				contentType: 'application/json',
				data: JSON.stringify(data)
			});
		}

		request.done(function(res) {
			var bsModal = bootstrap.Modal.getInstance($modal[0]);
			if (bsModal) bsModal.hide();
		}).fail(function(err) {
			console.error('Failed to save status.', err);
		});
	});

	$(document).on('click', '.js-status-edit', function() {
		var $row = $(this).closest('.js-status-row');
		var $modal = $row.closest('.js-project-status-modal');
		var $form = $modal.find('.js-status-form');

		$form.find('.js-status-edit-id').val($row.data('status-id'));
		$form.find('.js-status-time-note').val($row.find('[data-field="time"]').text() || '');
		$form.find('.js-status-budget-note').val($row.find('[data-field="budget"]').text() || '');
		$form.find('.js-status-quality-note').val($row.find('[data-field="quality"]').text() || '');

		var badge = $row.find('.badge').first();
		var badgeText = badge.text().trim();
		if (badgeText === i18next.t('green')) $form.find('.js-status-value').val('green');
		else if (badgeText === i18next.t('yellow')) $form.find('.js-status-value').val('yellow');
		else $form.find('.js-status-value').val('red');

		$form.find('.js-status-form-title').text(i18next.t('Edit check-in'));
		$form.find('.js-status-save').text(i18next.t('Edit'));
		$form.find('.js-status-cancel-edit').removeClass('d-none');
	});

	$(document).on('click', '.js-status-cancel-edit', function() {
		var $form = $(this).closest('.js-status-form');
		$form.find('.js-status-edit-id').val('');
		$form.find('.js-status-time-note').val('');
		$form.find('.js-status-budget-note').val('');
		$form.find('.js-status-quality-note').val('');
		$form.find('.js-status-value').val('green');
		$form.find('.js-status-form-title').text(i18next.t('Check In'));
		$form.find('.js-status-save').text(i18next.t('Check In'));
		$form.find('.js-status-cancel-edit').addClass('d-none');
	});

	$(document).on('click', '.js-status-delete', function() {
		var statusId = $(this).data('status-id');
		if (!confirm(i18next.t('Delete this status entry?'))) return;

		var $modal = $(this).closest('.js-project-status-modal');
		var projectId = $modal.data('project-id');

		$.ajax({
			url: '/api/project-status/' + statusId,
			method: 'DELETE'
		}).done(function() {
			var bsModal = bootstrap.Modal.getInstance($modal[0]);
			if (bsModal) bsModal.hide();
		}).fail(function(err) {
			console.error('Failed to delete status.', err);
		});
	});
})();
